import { useState } from "react"

export default function DynamicList({
  label,
  items = [],
  setItems,
  max = 5,
  hasImage = false
}) {
  const [nome, setNome] = useState("")
  const [file, setFile] = useState(null)

  const handleAdd = () => {
    if (!nome) return
    if (hasImage && !file) return
    if (items.length >= max) return

    const newItem = {
      nome,
      ...(hasImage && {
        file,
        preview: URL.createObjectURL(file)
      })
    }

    setItems([...items, newItem])
    setNome("")
    setFile(null)
  }

  const removeItem = (index) => {
    setItems(items.filter((_, i) => i !== index))
  }

  return (
    <div className="space-y-2">
      <Label className="text-sm font-medium">{label}</Label>

      <div className="flex items-center gap-2">
        <input
          value={nome}
          onChange={(e) => setNome(e.target.value)}
          placeholder={`Nome de ${label.toLowerCase()}`}
          className="flex-1 h-9 rounded-md border border-input bg-transparent px-3 text-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
        />

        {hasImage && (
          <label className="flex items-center gap-2 h-9 rounded-md border border-input bg-transparent px-3 text-sm cursor-pointer hover:bg-accent/50 transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" x2="12" y1="3" y2="15"/></svg>
            <span className="text-muted-foreground text-xs whitespace-nowrap">
              {file ? file.name : "Escolher"}
            </span>
            <input
              type="file"
              accept="image/*"
              className="hidden"
              onChange={(e) => setFile(e.target.files?.[0])}
            />
          </label>
        )}

        <button
          type="button"
          onClick={handleAdd}
          className="h-9 w-9 flex items-center justify-center rounded-md bg-primary text-primary-foreground hover:bg-primary/90 transition-colors shrink-0"
          title="Adicionar"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="M12 5v14"/></svg>
        </button>
      </div>

      {items.length > 0 && (
        <div className="space-y-1">
          {items.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-3 py-1.5 px-2 rounded-md bg-muted/50"
            >
              {item.preview && (
                <img
                  src={item.preview}
                  alt=""
                  width={32}
                  height={32}
                  className="rounded object-cover"
                />
              )}
              <span className="flex-1 text-sm truncate">{item.nome}</span>
              <button
                type="button"
                onClick={() => removeItem(i)}
                className="text-muted-foreground hover:text-destructive transition-colors"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/></svg>
              </button>
            </div>
          ))}
        </div>
      )}

      <p className="text-xs text-muted-foreground">
        {items.length}/{max}
      </p>
    </div>
  )
}

function Label({ children, className = "" }) {
  return (
    <label className={`text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 ${className}`}>
      {children}
    </label>
  )
}
